import * as React from "react";
import moment from "moment";
import {useNavigate} from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import RateReviewIcon from "@mui/icons-material/RateReview";

import ScoreRing from "@/components/ScoreRing";
import {getPipelineEntry, getPipelineStage} from "@/utils/scoutingPipeline";

import "./index.scss";

// Riga compatta per mobile: nome, poi ruolo · squadra · anno.
export default function ScoutingPlayerCard(props) {
	const {element} = props;
	const navigate = useNavigate();

	const birthYear = moment(element.dateOfBirth)?.year();
	const role =
		element.internalRole?.code ||
		(element.goalkeeper
			? "Portiere"
			: element.secondaryRole || element.primaryRole);

	const rating =
		element.reportsAverage == null
			? null
			: Number(element.reportsAverage.toFixed(2));
	const trend = element.reportsTrend;
	const pipelineStage = getPipelineStage(getPipelineEntry(element?.id)?.status);

	return (
		<div className="scout-player-row">
			<div className="scout-player-row__main">
				<div className="scout-player-row__name">
					{element.lastName}
					{element.firstName ? <span> {element.firstName}</span> : null}
				</div>
				<div className="scout-player-row__meta">
					{[
						role,
						(element.memberships || [])
							.map((r) => r.club?.name)
							.filter(Boolean)
							.join(" / ") || element.roster?.club?.name,
						birthYear > 1900 && birthYear,
					]
						.filter(Boolean)
						.join(" · ")}
				</div>
			</div>
			<div className="scout-player-row__side">
				{pipelineStage && (
					<span
						className="scout-player-row__stage"
						style={{background: pipelineStage.dot}}
						title={pipelineStage.label}
						aria-label={pipelineStage.label}
					/>
				)}
				{rating !== null && (
					<span
						className="scout-player-row__rating"
						title="Media relazioni della stagione"
					>
						<ScoreRing value={rating} max={5} size="small" />
						{trend && (
							<span className={`rating-trend rating-trend--${trend}`}>
								{trend === "up" && "↑"}
								{trend === "down" && "↓"}
								{trend === "flat" && "→"}
							</span>
						)}
					</span>
				)}
				{element.valuationsAverage != null && (
					<span
						title="Media valutazioni storiche della stagione"
						style={{fontSize: 11, color: "#64748b"}}
					>
						Storico {element.valuationsAverage.toFixed(2)}
					</span>
				)}
				<Tooltip title="Nuova relazione">
					<IconButton
						size="small"
						color="primary"
						aria-label="Nuova relazione"
						onClick={(event) => {
							event.stopPropagation();
							navigate("/scouting/relazioni/new?playerId=" + element.id);
						}}
					>
						<RateReviewIcon fontSize="small" />
					</IconButton>
				</Tooltip>
			</div>
		</div>
	);
}
